import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { ChartService } from '@services/chart/chart.service';

@Component({
  selector: 'app-navigator',
  templateUrl: './navigator.component.html',
  styleUrl: './navigator.component.scss'
})
export class NavigatorComponent implements OnInit, OnDestroy {
  navigatorViews = [
    {name: 'users', path: '/users'},
    {name: 'charts', path: '/charts'},
    {name: 'devices', path: '/devices'},
  ]
  show: boolean = true;
  currentRoute: string = '';
  
  private subscriptions: Subscription = new Subscription();

  constructor(
    private router: Router,
    private chartService: ChartService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.currentRoute = this.router.url;
    this.subscriptions.add(
      this.router.events.pipe(filter((evt) => evt instanceof NavigationEnd)).subscribe(() => {
      this.currentRoute = this.router.url;
    }));
    this.subscriptions.add(
      this.chartService.yearMonth$.subscribe(value => {
      this.show = value.length > 0;
      this.cdr.detectChanges();
    }));
  }

  isRouteActive(route: string): boolean {
    const currentPath = (this.currentRoute || '').split('?')[0];

    if (route === '/charts') {
      if (currentPath === '/charts') return true;

      const first = currentPath.replace(/^\/+/, '').split('/')[0];
      if (!first) return false;

      // Any dynamic content hierarchy route should highlight "charts".
      const reserved = new Set(['home', 'login', 'charts', 'users', 'devices', 'legal-disclaimer', 'cookie-policy']);
      return !reserved.has(first);
    }

    return currentPath === route;
  }

  goToPath(path: string) {
    if(this.currentRoute !== path) this.router.navigate([path]);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
